<script>
  import { getContext } from 'svelte'
  import { formatDateAxis, formatMillions } from '../functions.js'
  export let type = 'y'
  export let ticks = { x: null, y: null }
  export let scale = { x: null, y: null }
  export let height, width
  let { margin } = getContext('chart')
</script>

{#if type === 'x'}
  {#each ticks.x as tick}
    <text class="axis x-axis" y={height - margin.bottom / 2} x={scale.x(tick)}
      >{formatDateAxis(tick)}</text
    >
    <line
      class="axis x-axis"
      y1={height - margin.bottom}
      y2={height - margin.bottom - 5}
      x1={scale.x(tick)}
      x2={scale.x(tick)}
      stroke="#000"
    />
  {/each}
{:else if type === 'y'}
  {#each ticks.y as tick}
    <text class="axis y-axis" x={margin.left - 10} y={scale.y(tick)}
      >{formatMillions(tick)}</text
    >
  {/each}
{/if}
